/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import './Footer.css';
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';

const Daccord = () => {

    const navigate = useNavigate();

    const inscription = () => {
          navigate("/FInscription");
    };
    
    return (
      
      <div className="footers">
                
        <footer className="footer">
          <div >
            <div className="container">
              <div className="row text-center">
                <div className="col-sm-12">
                  <div className="widget-copyright">

                    <h5>
                      <a style={{color:'#d61515ff'}}> 
                      Voulez-vous vous inscrire  en ligne ?   {""} {""}
                      
                       <button className="button-identification" onClick={()=>inscription()}>
                         Oui
                      </button>
                      </a>
                      
                    </h5>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>

      </div>
    );
};

export default Daccord;